import { spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  input: {
    paddingTop: spacing.s,
    paddingBottom: spacing.xxs,
  },
};
